export default "__VITE_ASSET__C44yw4rQ__"